function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M87.58,0.06l-75-0.12C5.676-0.071,0.071,5.516,0.06,12.42l-0.12,75c-0.011,6.902,5.576,12.509,12.48,12.521l75,0.119 c6.902,0.012,12.509-5.577,12.521-12.479l0.119-75C100.071,5.676,94.482,0.071,87.58,0.06z M93.849,21.124L40.077,74.723 c-1.653,1.648-4.334,1.645-5.983-0.01L11.652,52.198c-1.649-1.654-1.645-4.333,0.009-5.982c1.655-1.649,4.334-1.645,5.984,0.01 L37.1,65.742L87.875,15.13c1.654-1.649,4.334-1.645,5.983,0.01C95.508,16.795,95.504,19.475,93.849,21.124z"
});

var SvgCheckOn = function SvgCheckOn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCheckOn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check_on.05ff6eda.svg";
export { ForwardRef as ReactComponent };